import { render, staticRenderFns } from "./PackingSlips.vue?vue&type=template&id=1dc6c8c7&scoped=true&lang=pug&"
import script from "./PackingSlips.vue?vue&type=script&lang=js&"
export * from "./PackingSlips.vue?vue&type=script&lang=js&"
import style0 from "./PackingSlips.vue?vue&type=style&index=0&id=1dc6c8c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc6c8c7",
  null
  
)

/* custom blocks */
import block0 from "./PackingSlips.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VDivider,VImg,VLayout,VProgressCircular,VRow,VSpacer})
